/**
 * AUTO-GENERATED — do not edit by hand.
 * Regenerate with: node scripts/widgets/generate-widget-schemas.js
 *
 * Lightweight metadata manifest of every registered widget's props-schema
 * (data only — no component code). Used by the widget pickers so opening them
 * does not download every widget chunk. Kept in sync with ./index.js by
 * __tests__/schemas.parity.test.js.
 */
/* eslint-disable */
import AccordionSchema from './Accordion/versions/0.0.1/props-schema';
import AddToCalendarSchema from './AddToCalendar/versions/0.0.1/props-schema';
import AiGeneratedWidgetSchema from './AiGeneratedWidget/versions/0.0.1/props-schema';
import AiHyperArchitectureSchema from './AiHyperArchitecture/versions/0.0.1/props-schema';
import AnimatedImageSchema from './AnimatedImage/versions/0.0.1/props-schema';
import AppDownloadButtonSchema from './AppDownloadButton/versions/0.0.1/props-schema';
import AppSectionSchema from './AppSection/versions/0.0.1/props-schema';
import AssetsDownloadSchema from './AssetsDownload/versions/0.0.1/props-schema';
import AttentionBarSchema from './AttentionBar/versions/0.0.1/props-schema';
import BackgroundImageWithTextSchema from './BackgroundImageWithText/versions/0.0.1/props-schema';
import BannerSchema from './Banner/versions/0.0.1/props-schema';
import BillboardSchema from './Billboard/versions/0.0.1/props-schema';
import BioOverlaySchema from './BioOverlay/versions/0.0.1/props-schema';
import BoldButtonSchema from './BoldButton/versions/0.0.1/props-schema';
import BreadCrumbsSchema from './BreadCrumbs/versions/0.0.1/props-schema';
import C10CardSectionSchema from './C10CardSection/versions/0.0.1/props-schema';
import C10CenterMessageSchema from './C10CenterMessage/versions/0.0.1/props-schema';
import C10DescriptionBlocksSchema from './C10DescriptionBlocks/versions/0.0.1/props-schema';
import C10HeroSectionSchema from './C10HeroSection/versions/0.0.1/props-schema';
import C10SimpleBlocksSchema from './C10SimpleBlocks/versions/0.0.1/props-schema';
import C10VerticalBlocksSchema from './C10VerticalBlocks/versions/0.0.1/props-schema';
import CancelFreeRideSchema from './CancelFreeRide/versions/0.0.1/props-schema';
import CharacterBioSchema from './CharacterBio/versions/0.0.1/props-schema';
import ColumnHighlightSchema from './ColumnHighlight/versions/0.0.1/props-schema';
import ColumnsSchema from './Columns/versions/0.0.1/props-schema';
import ContactBlockSchema from './ContactBlock/versions/0.0.1/props-schema';
import CopyLandingSchema from './CopyLanding/versions/0.0.1/props-schema';
import CTABannerSchema from './CTABanner/versions/0.0.1/props-schema';
import CTASectionSchema from './CTASection/versions/0.0.1/props-schema';
import CTAWidgetSchema from './CTAWidget/versions/0.0.1/props-schema';
import CustomWidgetSchema from './CustomWidget/versions/0.0.1/props-schema';
import DemoDriveApplicationSchema from './DemoDriveApplication/versions/0.0.1/props-schema';
import DescriptionBlocksSchema from './DescriptionBlocks/versions/0.0.1/props-schema';
import DescriptiveGallerySchema from './DescriptiveGallery/versions/0.0.1/props-schema';
import DescriptiveImageSchema from './DescriptiveImage/versions/0.0.1/props-schema';
import DescriptiveIntroSchema from './DescriptiveIntro/versions/0.0.1/props-schema';
import DoubleHeadSchema from './DoubleHead/versions/0.0.1/props-schema';
import EventFormSchema from './EventForm/versions/0.0.1/props-schema';
import EventHeroImageSchema from './EventHeroImage/versions/0.0.1/props-schema';
import EventListSchema from './EventList/versions/0.0.1/props-schema';
import EventPreviewSchema from './EventPreview/versions/0.0.1/props-schema';
import FancySlideShowSchema from './FancySlideShow/versions/0.0.1/props-schema';
import FAQSchema from './FAQ/versions/0.0.1/props-schema';
import FeatureBlocksSchema from './FeatureBlocks/versions/0.0.1/props-schema';
import FeatureListSchema from './FeatureList/versions/0.0.1/props-schema';
import FlexibleColumnsSchema from './FlexibleColumns/versions/0.0.1/props-schema';
import FlexibleGallerySchema from './FlexibleGallery/versions/0.0.1/props-schema';
import FlexibleHTMLSchema from './FlexibleHTML/versions/0.0.1/props-schema';
import FloatingCTASchema from './FloatingCTA/versions/0.0.1/props-schema';
import FooterSchema from './Footer/versions/0.0.1/props-schema';
import FootnoteSchema from './Footnote/versions/0.0.1/props-schema';
import FormulaECalendarSchema from './FormulaECalendar/versions/0.0.1/props-schema';
import FullPageSideTextSchema from './FullPageSideText/versions/0.0.1/props-schema';
import FutureSightFeaturesSchema from './FutureSightFeatures/versions/0.0.1/props-schema';
import FutureSightImageSchema from './FutureSightImage/versions/0.0.1/props-schema';
import FutureSightSeparatorSchema from './FutureSightSeparator/versions/0.0.1/props-schema';
import GalleryIndexSchema from './GalleryIndex/versions/0.0.1/props-schema';
import GenericSeparatorSchema from './GenericSeparator/versions/0.0.1/props-schema';
import GoogleMapSchema from './GoogleMap/versions/0.0.1/props-schema';
import HeroImageGridSchema from './HeroImageGrid/versions/0.0.1/props-schema';
import HeroLandingSchema from './HeroLanding/versions/0.0.1/props-schema';
import HomepageCarouselSchema from './HomepageCarousel/versions/0.0.1/props-schema';
import HomePageGallerySchema from './HomePageGallery/versions/0.0.1/props-schema';
import HTMLSchema from './HTML/versions/0.0.1/props-schema';
import ImageCarouselSchema from './ImageCarousel/versions/0.0.1/props-schema';
import ImageGallerySchema from './ImageGallery/versions/0.0.1/props-schema';
import ImageSectionsSchema from './ImageSections/versions/0.0.1/props-schema';
import ImageTextGridSchema from './ImageTextGrid/versions/0.0.1/props-schema';
import ImageWithTextInCornerSchema from './ImageWithTextInCorner/versions/0.0.1/props-schema';
import InTheNewsSchema from './InTheNews/versions/0.0.1/props-schema';
import JobsSchema from './Jobs/versions/0.0.1/props-schema';
import LabelSchema from './Label/versions/0.0.1/props-schema';
import LabHeadingSchema from './LabHeading/versions/0.0.1/props-schema';
import LabImageTextGridSchema from './LabImageTextGrid/versions/0.0.1/props-schema';
import LivestreamCarouselSchema from './LivestreamCarousel/versions/0.0.1/props-schema';
import LivestreamTcPlayerSchema from './LivestreamTcPlayer/versions/0.0.1/props-schema';
import LivestreamVideoPlayerSchema from './LivestreamVideoPlayer/versions/0.0.1/props-schema';
import MapViewHeaderSchema from './MapViewHeader/versions/0.0.1/props-schema';
import MasonrySchema from './Masonry/versions/0.0.1/props-schema';
import MediaDownloadSchema from './MediaDownload/versions/0.0.1/props-schema';
import ModelCompareSchema from './ModelCompare/versions/0.0.1/props-schema';
import MondrianGridSchema from './MondrianGrid/versions/0.0.1/props-schema';
import NonDescriptiveIntroSchema from './NonDescriptiveIntro/versions/0.0.1/props-schema';
import OnionPeelSchema from './OnionPeel/versions/0.0.1/props-schema';
import PressroomListSchema from './PressroomList/versions/0.0.1/props-schema';
import PressroomWeeklyListSchema from './PressroomWeeklyList/versions/0.0.1/props-schema';
import ProductSlideShowSchema from './ProductSlideShow/versions/0.0.1/props-schema';
import QRColumnsSchema from './QRColumns/versions/0.0.1/props-schema';
import QuestionsSchema from './Questions/versions/0.0.1/props-schema';
import RedirectSchema from './Redirect/versions/0.0.1/props-schema';
import RelatedArticlesSchema from './RelatedArticles/versions/0.0.1/props-schema';
import ResponsiveDisplayContainerSchema from './ResponsiveDisplayContainer/versions/0.0.1/props-schema';
import RichTextSchema from './RichText/versions/0.0.1/props-schema';
import ScrollGallerySchema from './ScrollGallery/versions/0.0.1/props-schema';
import ScrollVideoSchema from './ScrollVideo/versions/0.0.1/props-schema';
import SectionIntroSchema from './SectionIntro/versions/0.0.1/props-schema';
import SectionParagraphSchema from './SectionParagraph/versions/0.0.1/props-schema';
import ServiceCommitmentSchema from './ServiceCommitment/versions/0.0.1/props-schema';
import ShowcaseSchema from './Showcase/versions/0.0.1/props-schema';
import SimpleFooterSchema from './SimpleFooter/versions/0.0.1/props-schema';
import SimpleFXReservationSchema from './SimpleFXReservation/versions/0.0.1/props-schema';
import SimpleReservationSchema from './SimpleReservation/versions/0.0.1/props-schema';
import SitemapSchema from './Sitemap/versions/0.0.1/props-schema';
import SocialMediaMessageLayoutSchema from './SocialMediaMessageLayout/versions/0.0.1/props-schema';
import SpecsSheetSchema from './SpecsSheet/versions/0.0.1/props-schema';
import StickyBarSchema from './StickyBar/versions/0.0.1/props-schema';
import StickySubNavSchema from './StickySubNav/versions/0.0.1/props-schema';
import StoreLocationSchema from './StoreLocation/versions/0.0.1/props-schema';
import SubscribeSchema from './Subscribe/versions/0.0.1/props-schema';
import SubscribeInterestsSchema from './SubscribeInterests/versions/0.0.1/props-schema';
import SubscribeV2Schema from './SubscribeV2/versions/0.0.1/props-schema';
import TabCarouselSchema from './TabCarousel/versions/0.0.1/props-schema';
import TabMenuSchema from './TabMenu/versions/0.0.1/props-schema';
import TinyMCESchema from './TinyMCE/versions/0.0.1/props-schema';
import TitledItemListSchema from './TitledItemList/versions/0.0.1/props-schema';
import TitleImageSchema from './TitleImage/versions/0.0.1/props-schema';
import TitleTextSchema from './TitleText/versions/0.0.1/props-schema';
import TransitionSectionSchema from './TransitionSection/versions/0.0.1/props-schema';
import TwoColumnDescriptionSchema from './TwoColumnDescription/versions/0.0.1/props-schema';
import VerticalNavBarSchema from './VerticalNavBar/versions/0.0.1/props-schema';
import VideoImageCarouselSchema from './VideoImageCarousel/versions/0.0.1/props-schema';
import VideoParallaxSchema from './VideoParallax/versions/0.0.1/props-schema';
import VideoPlayerSchema from './VideoPlayer/versions/0.0.1/props-schema';
import VideoTwoUpsSchema from './VideoTwoUps/versions/0.0.1/props-schema';
import VRModuleSchema from './VRModule/versions/0.0.1/props-schema';
import WaterfallGallerySchema from './WaterfallGallery/versions/0.0.1/props-schema';

export default {
  Accordion: AccordionSchema,
  AddToCalendar: AddToCalendarSchema,
  AiGeneratedWidget: AiGeneratedWidgetSchema,
  AiHyperArchitecture: AiHyperArchitectureSchema,
  AnimatedImage: AnimatedImageSchema,
  AppDownloadButton: AppDownloadButtonSchema,
  AppSection: AppSectionSchema,
  AssetsDownload: AssetsDownloadSchema,
  AttentionBar: AttentionBarSchema,
  BackgroundImageWithText: BackgroundImageWithTextSchema,
  Banner: BannerSchema,
  Billboard: BillboardSchema,
  BioOverlay: BioOverlaySchema,
  BoldButton: BoldButtonSchema,
  BreadCrumbs: BreadCrumbsSchema,
  C10CardSection: C10CardSectionSchema,
  C10CenterMessage: C10CenterMessageSchema,
  C10DescriptionBlocks: C10DescriptionBlocksSchema,
  C10HeroSection: C10HeroSectionSchema,
  C10SimpleBlocks: C10SimpleBlocksSchema,
  C10VerticalBlocks: C10VerticalBlocksSchema,
  CancelFreeRide: CancelFreeRideSchema,
  CharacterBio: CharacterBioSchema,
  ColumnHighlight: ColumnHighlightSchema,
  Columns: ColumnsSchema,
  ContactBlock: ContactBlockSchema,
  CopyLanding: CopyLandingSchema,
  CTABanner: CTABannerSchema,
  CTASection: CTASectionSchema,
  CTAWidget: CTAWidgetSchema,
  CustomWidget: CustomWidgetSchema,
  DemoDriveApplication: DemoDriveApplicationSchema,
  DescriptionBlocks: DescriptionBlocksSchema,
  DescriptiveGallery: DescriptiveGallerySchema,
  DescriptiveImage: DescriptiveImageSchema,
  DescriptiveIntro: DescriptiveIntroSchema,
  DoubleHead: DoubleHeadSchema,
  EventForm: EventFormSchema,
  EventHeroImage: EventHeroImageSchema,
  EventList: EventListSchema,
  EventPreview: EventPreviewSchema,
  FancySlideShow: FancySlideShowSchema,
  FAQ: FAQSchema,
  FeatureBlocks: FeatureBlocksSchema,
  FeatureList: FeatureListSchema,
  FlexibleColumns: FlexibleColumnsSchema,
  FlexibleGallery: FlexibleGallerySchema,
  FlexibleHTML: FlexibleHTMLSchema,
  FloatingCTA: FloatingCTASchema,
  Footer: FooterSchema,
  Footnote: FootnoteSchema,
  FormulaECalendar: FormulaECalendarSchema,
  FullPageSideText: FullPageSideTextSchema,
  FutureSightFeatures: FutureSightFeaturesSchema,
  FutureSightImage: FutureSightImageSchema,
  FutureSightSeparator: FutureSightSeparatorSchema,
  GalleryIndex: GalleryIndexSchema,
  GenericSeparator: GenericSeparatorSchema,
  GoogleMap: GoogleMapSchema,
  HeroImageGrid: HeroImageGridSchema,
  HeroLanding: HeroLandingSchema,
  HomepageCarousel: HomepageCarouselSchema,
  HomePageGallery: HomePageGallerySchema,
  HTML: HTMLSchema,
  ImageCarousel: ImageCarouselSchema,
  ImageGallery: ImageGallerySchema,
  ImageSections: ImageSectionsSchema,
  ImageTextGrid: ImageTextGridSchema,
  ImageWithTextInCorner: ImageWithTextInCornerSchema,
  InTheNews: InTheNewsSchema,
  Jobs: JobsSchema,
  Label: LabelSchema,
  LabHeading: LabHeadingSchema,
  LabImageTextGrid: LabImageTextGridSchema,
  LivestreamCarousel: LivestreamCarouselSchema,
  LivestreamTcPlayer: LivestreamTcPlayerSchema,
  LivestreamVideoPlayer: LivestreamVideoPlayerSchema,
  MapViewHeader: MapViewHeaderSchema,
  Masonry: MasonrySchema,
  MediaDownload: MediaDownloadSchema,
  ModelCompare: ModelCompareSchema,
  MondrianGrid: MondrianGridSchema,
  NonDescriptiveIntro: NonDescriptiveIntroSchema,
  OnionPeel: OnionPeelSchema,
  PressroomList: PressroomListSchema,
  PressroomWeeklyList: PressroomWeeklyListSchema,
  ProductSlideShow: ProductSlideShowSchema,
  QRColumns: QRColumnsSchema,
  Questions: QuestionsSchema,
  Redirect: RedirectSchema,
  RelatedArticles: RelatedArticlesSchema,
  ResponsiveDisplayContainer: ResponsiveDisplayContainerSchema,
  RichText: RichTextSchema,
  ScrollGallery: ScrollGallerySchema,
  ScrollVideo: ScrollVideoSchema,
  SectionIntro: SectionIntroSchema,
  SectionParagraph: SectionParagraphSchema,
  ServiceCommitment: ServiceCommitmentSchema,
  Showcase: ShowcaseSchema,
  SimpleFooter: SimpleFooterSchema,
  SimpleFXReservation: SimpleFXReservationSchema,
  SimpleReservation: SimpleReservationSchema,
  Sitemap: SitemapSchema,
  SocialMediaMessageLayout: SocialMediaMessageLayoutSchema,
  SpecsSheet: SpecsSheetSchema,
  StickyBar: StickyBarSchema,
  StickySubNav: StickySubNavSchema,
  StoreLocation: StoreLocationSchema,
  Subscribe: SubscribeSchema,
  SubscribeInterests: SubscribeInterestsSchema,
  SubscribeV2: SubscribeV2Schema,
  TabCarousel: TabCarouselSchema,
  TabMenu: TabMenuSchema,
  TinyMCE: TinyMCESchema,
  TitledItemList: TitledItemListSchema,
  TitleImage: TitleImageSchema,
  TitleText: TitleTextSchema,
  TransitionSection: TransitionSectionSchema,
  TwoColumnDescription: TwoColumnDescriptionSchema,
  VerticalNavBar: VerticalNavBarSchema,
  VideoImageCarousel: VideoImageCarouselSchema,
  VideoParallax: VideoParallaxSchema,
  VideoPlayer: VideoPlayerSchema,
  VideoTwoUps: VideoTwoUpsSchema,
  VRModule: VRModuleSchema,
  WaterfallGallery: WaterfallGallerySchema,
};
